<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_347_8640)">
      <mask
        id="mask0_347_8640"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24">
        <path d="M0 0H24V24H0V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_347_8640)">
        <path
          d="M22.152 3.55273L11.178 21.0037L9.508 12.4077L2 7.89773L22.152 3.55273ZM22.152 3.55273L9.456 12.4437"
          stroke="var(--svg-col, #261F4D)"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round" />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_347_8640">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
